export default function containsUppercaseValidator(val) {
    const regexUppercase = /[A-Z]/;
    return val && regexUppercase.test(val);
}